import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "../../API/axios";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import moment from "moment";
import ReactSelect from "react-select";

import PreviewSharpIcon from "@mui/icons-material/PreviewSharp";
import { Modal, Col, Form, Row } from "react-bootstrap";
import HiringStatus from "./HiringStatus";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import ThumbDownAltSharpIcon from "@mui/icons-material/ThumbDownAltSharp";
import DoneAllSharpIcon from "@mui/icons-material/DoneAllSharp";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import ClearSharpIcon from "@mui/icons-material/ClearSharp";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import Tooltip from "@mui/material/Tooltip";
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';

import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import VerticalAlignBottomSharpIcon from "@mui/icons-material/VerticalAlignBottomSharp";
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import SearchIcon from "@mui/icons-material/Search";
import toast from "react-hot-toast";
import { format } from "date-fns";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import { customStyles } from "../../selectStyles";




const InterviewSchedule = () => {
	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");

	const [showAcceptModal, setShowAcceptModal] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [interviewData, setInterviewData] = useState([]);
	console.log("interviewData", interviewData);

	const [activeTab, setActiveTab] = useState("Candidate");
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);
	const [isCandidate, setisCandidate] = useState("Candidate");
	const [unAuthorizeError, setUnAuthorizeError] = useState("");

	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);


	// User Info modal state
	const [showUserInfo, setUserInfo] = useState(false);
	const handleShowInfo = () => setUserInfo(true);
	const handleCloseInfo = () => setUserInfo(false);

	const [showRemarkModal, setShowRemarkModal] = useState(false);
	const handleShowRemark = () => setShowRemarkModal(true);
	const handleCloseRemark = () => setShowRemarkModal(false);

	const [showInsRemarkModal, setShowInsRemarkModal] = useState(false);
	const handleShowInsRemark = () => setShowInsRemarkModal(true);
	const handleCloseInsRemark = () => setShowInsRemarkModal(false);


	const [totalRows, setTotalRows] = useState(1);

	const [jobAppId, setjobAppId] = useState(0);
	const [jobAppType, setjobAppType] = useState(0);
	const [candidId, setcandidId] = useState(0);
	const [InsttUid, setInsttUid] = useState(0);
	const [grpTypename, setgrpTypename] = useState(0);
	const [grpTypeId, setgrpTypeId] = useState(0);
	const [CantId, setCantId] = useState(0);
	// const [grpTypeId, setgrpTypeId] = useState(0);
	const [jobAppInfoData, setJobAppInfoData] = useState([]);
	const [displays, setDisplays] = useState(false);

	const [interviewType, setInterviewType] = useState("Candidate");
	const [originalData, setOriginalData] = useState([]); // Pure data ke liye
	const [originalCandidateList, setOriginalCandidateList] = useState([]); // Pure data ke liye

	console.log("InsttUid", InsttUid);

	const handleTabChange = (tab) => {

		const type = tab === 2 ? "Institution" : "Candidate";

		setInterviewType(prevType => {
			// console.log("Updating type:", prevType, "=>", type);
			return type;
		});

		getInterviewShedule(1, type);

		const filteredData = originalCandidateList.filter(item => item.type === type);
		setCandidateList(filteredData);
	};


	useEffect(() => {

		if (interviewType) {
			getInterviewShedule(currentPage, interviewType);
		}
	}, [interviewType,currentPage]); 

	const getInterviewShedule = async (page, type) => {
		if (!type) {
			return;
		}
		try {
			const requestBody = {
				sessionId: sessionId,
				pageNumber: page,
				pageSize: 10,
			};
			// const response = await axios.post(
			// 	`JobApplication/GetAllInterviews?Type=${type}`,
			// 	requestBody
			// );

			// const res = response?.data?.responseData || {};
			// if (!res?.allJobInterviews?.length) {
			// 	console.warn(` No data found for type: ${type}`);
			// }
			// setInterviewData(res?.allJobInterviews || []);
			// setTotalRows(response?.data?.responseData?.paging?.totalrecords || 0);
			// setIsLoading(false);
			// console.log("GetAllInterviewSechedule", res);
			axios
				.post(`JobApplication/GetAllInterviews?Type=${type}`, requestBody)
				.then((response) => {
					const res = response?.data?.responseData || {};
					if (!res?.allJobInterviews?.length) {
						console.warn(` No data found for type: ${type}`);
					}
					setInterviewData(res?.allJobInterviews || []);
					setTotalRows(response?.data?.responseData?.paging?.totalrecords || 0);
					setIsLoading(false);
					console.log("GetAllInterviewSechedule", res);
					setIsError(res.length === 0);
				})
				.catch((err) => {
					console.error("Error fetching jobs:", err);
					setIsError(true); // Handle error state
					setIsLoading(false);
					if (err.response && err.response.status === 409) {
						// toast.error(err.response.data.message);
						console.error("Unexpected error:", err);
						setUnAuthorizeError(err.response.data.message)
						handleunauthModal()
					} else {
						console.error("Unexpected error:", err);

					}
				});

		} catch (error) {
			console.error("API Error:", error);
			setIsError(true);
		}
	};
	console.log("InterviewData====>", interviewData)
	const tabStyle = (isActive) => ({
		cursor: "pointer",
		//   width: "100px", 
		height: "50px",
		lineHeight: "50px",
		textAlign: "center",
		border: "none", // Removes all borders
		borderBottom: isActive ? "3px solid #feaa00" : "none", // Keeps only the bottom border
		backgroundColor: "transparent", // Ensures no background interference
	});


	useEffect(() => {
		// getInterviewShedule(currentPage);
	}, [interviewType, currentPage]);

	const handleClose = () => {
		setShowAcceptModal(false);
	};

	const getJobAppInfo = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
			};
			const response = await axios.post("/JobApplication/GetInfo", requestBody);
			setJobAppInfoData(response.data.responseData);
		} catch (error) {
			console.error("API Error:", error);
		}
	};


	const [showAppliedModal, setShowAppliedModal] = useState(false);
	const [candidateList, setCandidateList] = useState([]);

	// Handlers to open and close the modal
	const handleShowModal = () => setShowAppliedModal(true);
	const handleCloseModal = () => setShowAppliedModal(false);

	const handleCancel = () => {
		setShowConfirmationModal(false);
	};
	const handleCancelIns = () => {
		setShowConfirmationModalIns(false);
	};

	const [showInstModal, setShowInstModal] = useState(false);
	const handleInstModal = () => setShowInstModal(true);
	const handleCloseInstModal = () => setShowInstModal(false);

	// const [showInstConfirmationModal, setShowInstConfirmationModal] =
	// 	useState(false);
	// const handleInstShowModal = () => setShowInstConfirmationModal(true);
	// const handleInstituteCancel = () => setShowInstConfirmationModal(false);

	const [search, setSearch] = useState("");
	const [InsCandidateList, setInsCandidateList] = useState([]);
	const [instituteId, setInstituteId] = useState("");


	const AcceptApplication = async (id, hiringStatus) => {

		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: id,
				hiringStatus: hiringStatus,
				remark: "",
			};
			const response = await axios.post(
				"/JobApplication/UpdateHiringStatus",
				requestBody
			);
			console.log("response", response);
			getInterviewShedule(1, "Candidate");
			toast.success(response.data.message);
			handleCancel();
			console.log("AcceptApplication Request:111", requestBody);

		} catch (error) {
			if (error.response) {
				toast.error(error.response.data?.message);
			} else {
				toast.error("Network error, please try again");
			}

		}
	};

	// const AcceptApplicationInsCandid = async (id, hiringStatus) => {
	// 	// console.log("hiringStatus", id, hiringStatus);

	// 	try {
	// 		const requestBody = {
	// 			sessionId: sessionId,
	// 			jbApplctnId: id,
	// 			hiringStatus: hiringStatus,
	// 			remark: "",
	// 		};

	// 		console.log("AcceptApplication Request:2222", requestBody);

	// 	} catch (error) {
	// 		toast.error(error);
	// 		console.error("API Error:", error);
	// 	}
	// };

	const getGetAllCandidate = (page) => {
		const data = {
			pageNumber: page,
			pageSize: 10,
		};
		axios
			.post(
				`/Candidate/GetAllByInstt/${instituteId}?Type=${"All"}&TypeId=${0}&Search=${search}`,
				data
			)
			.then((response) => {
				const res = response.data.responseData.items;
				setInsCandidateList(res);
				setIsLoading(false);
				// setDisplay(false);
			})
			.catch((e) => {
				console.error("Error fetching candidates:", e);
				if (e.response && e.response.status === 404) {
					//   setDisplay(true);
				}
			});
	};

	useEffect(() => {
		if (instituteId || search) {
			getGetAllCandidate();
		}
	}, [instituteId, search]);

	const [scheduleTime, setScheduleTime] = useState("");
	const [placeType, setPlaceType] = useState(0);
	const [placeDetails, setPlaceDetails] = useState("");
	const [remark, setRemark] = useState("");

	const JobAppGetAll = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				pageNumber: 1,
				pageSize: 10,
			};
			// console.log("requestBody", requestBody);
			const response = await axios.post("/JobApplication/GetAll", requestBody);

			setCandidateList(response.data.responseData.jobApplications);
		} catch (error) {
			console.error("API Error:", error);
		}
	};

	useEffect(() => {
		JobAppGetAll();
	}, []);



	const remarkUpdateFn = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				remark: updateRemark,
				cnddtID: null,
				type: jobAppType,
				insttCnddtsItrvwId: intrvwId,
				// cnddtID: candidId ? candidId : null,
			};

			const response = await axios.post(
				"/JobApplication/UpdateInterviewRemarks",
				requestBody
			);
			// console.log("API Response:", response.data.message);
			// const data = response.data.message
			toast.success(response.data.message)
			getInterviewShedule(1, "Candidate");
			handleCloseRemark();
			setCandidateList(response.data.responseData.jobApplications);
		} catch (error) {
			console.error("API Error:", error);
		}
	};

	const remarkUpdateInsCandi = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				remark: updateRemark,
				cnddtID: candidId,
				type: jobAppType,
				insttCnddtsItrvwId: intrvwId,
			};

			const response = await axios.post(
				"/JobApplication/UpdateInterviewRemarks",
				requestBody
			);
			// console.log("API Response:", response.data.message);
			// const data = response.data.message
			toast.success(response.data.message)
			getInterviewShedule(1, "Institution");

			// getInterviewShedule(1, "Institution");  
			handleCloseInsRemark();
			setCandidateList(response.data.responseData.jobApplications);
		} catch (error) {
			console.error("API Error:", error);
		}
	};

	const ScheduleInterview = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				scheduleTime: scheduleTime,
				// placeType: placeType,
				placeType: parseInt(placeType, 10), // Ensure it's a number
				placeDetails,
				remark,
			};
			console.log("requestBody", requestBody);

			const response = await axios.post(
				"/JobApplication/ScheduleInterview",
				requestBody
			);

			// console.log("getScheduleInterview", response);
			toast.success(response.data.message)
			// JobAppGetAll();
			getInterviewShedule(1, "Candidate");

			handleCloseModal(); // Close modal on success
			setScheduleTime("");
			setPlaceType(null);
			setPlaceDetails("");
			setRemark("");
		} catch (error) {
			// toast.error(error.data.message);
			toast.error(error);
			console.error("API Error:", error);
		}
	};

	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [applicationStatus, setApplicationStatus] = useState("");
	console.log("applicationStatus", applicationStatus)
	const [showConfirmationModalIns, setShowConfirmationModalIns] = useState(false);
	const [applicationStatusIns, setApplicationStatusIns] = useState("");

	//   console.log("acceptApplication", acceptApplication);
	const [instituteAppData, setInstituteAppData] = useState("");

	const [hiringStatuses, setHiringStatuses] = useState({});
	const [hiringStatusvalue, setHiringStatusvalue] = useState({});

	const InstituteCandidateHiringStatus = async (row) => {
		// console.log("function working");

		try {
			const updatedStatuses = { ...hiringStatuses }; // Copy existing statuses
			const updatedStatuses1 = { ...hiringStatusvalue }; // Copy existing statuses

			// Iterate over all candidates in the modal's candidate list
			for (const candidate of InsCandidateList) {
				const requestBody = {
					sessionId: sessionId,
					jbApplctnId: row.jbApplctnId,
					insttUid: row.userUid,
					cnddtID: candidate.cnddtId,
					grpTypName: row.grpTypName,
					grpTypeId: row.grpTypeId,
				};
				// console.log("function", requestBody, row);

				const response = await axios.post(
					"/JobApplication/GetInstituteCandidateHiringStatus",
					requestBody
				);
				console.log("function api working");
				// Store the hiring status in the state mapped by candidate ID
				updatedStatuses[candidate.cnddtId] =
					response.data.responseData.hiringStatusName;
				updatedStatuses1[candidate.cnddtId] =
					response.data.responseData.hiringStatus;
			}

			setHiringStatuses(updatedStatuses); // Update the state with new statuses
			setHiringStatusvalue(updatedStatuses1); // Update the state with new statuses
		} catch (error) {
			console.error("Error fetching hiring statuses:", error);
		}

		//   sethiringStatusIns(statuses);
		// } catch (error) {
		//   console.error("API Error:", error);
		// }
	};

	const AcceptApplicationAsInst = async (id, hiringStatus) => {
		console.log("AcceptApplication333");

		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: id,
				hiringStatus: hiringStatus,
				remark: "",
				insttUid: InsttUid,
				cnddtID: candidId,
				grpTypName: grpTypename,
				grpTypeId: grpTypeId,
			};
			console.log("AcceptApplication333", requestBody);

			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			);

			handleCancelIns();
			getInterviewShedule(1, "Institution");

		} catch (error) {
			toast.error(error.response);
			console.error("API Error:", error);
		}
	};
	const mapPlaceTypeToValue = {
		OnSite: "1",
		Remote: "2",
		Hybrid: "3",
	};

	const ScheduleInterviewAsInst = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				scheduleTime: scheduleTime,
				placeType: parseInt(placeType, 10),
				placeDetails,
				remark,
				insttUid: InsttUid,
				cnddtID: candidId,
				grpTypName: grpTypename,
				grpTypeId: grpTypeId,
			};
			console.log("ScheduleInterview", requestBody);

			const response = await axios.post(
				"/JobApplication/ScheduleInterviewForInstituteCandidates",
				requestBody
			);

			console.log("getScheduleInterview", response);
			// toast.success(response.data.message)
			toast.success("Interview Scheduled Successfully!");
			getInterviewShedule(1, "Institution");
			setScheduleTime("");
			setPlaceType(null);
			setPlaceDetails("");
			setRemark("");
			handleCloseModalScheule(); // Close modal on success

			InstituteCandidateHiringStatus(instituteAppData);
		} catch (error) {
			// toast.error("Some problem occurred!");
			toast.error(error.response.data.title);
			console.error("API Error:", error);
		}
	};

	// Handlers to open and close the modal
	const [showAppliedModalScheule, setShowAppliedModalScheule] = useState(false);
	const handleShowModalScheule = () => setShowAppliedModalScheule(true);
	const handleCloseModalScheule = () => setShowAppliedModalScheule(false);


	// ........................................Job History start..........................

	const [jobHistory, setJobHistory] = useState("");
	const [showHistoryModal, setShowHistoryModal] = useState(false);
	const handleHistoryShow = () => setShowHistoryModal(true);
	const handleCloseHistoryModal = () => setShowHistoryModal(false);

	const JobHistory = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetHistory", data).then((resData) => {
				console.log("HISTORY", resData.data.responseData);
				const data1 = resData.data.responseData;
				setJobHistory(data1);
			});
		} catch (e) {
			console.log("Unapply ");
		}
	};

	// ........................................Job History End..........................
	// ........................................Job info start..........................

	const [jobInfo, setJobInfo] = useState("");
	const [showInfoModal, setShowInfoModal] = useState(false);
	const handleInfoShow = () => setShowInfoModal(true);
	const handleCloseInfoModal = () => setShowInfoModal(false);

	const JobInfoData = (JobId) => {
		axios
			.get(`/Job/GetJobDetails?JobId=${JobId}`)
			.then((response) => {
				const res = response.data.responseData;
				setJobInfo(res);
				console.log("edit data", res);
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					console.log(error);
				} else {
					console.log(error);
				}
			});
	};

	// ..............................................Test Assign actions.................................................................


	const [testRemark, setTestRemark] = useState("");
	const [testName, setTestName] = useState("");
	const [testType, setTestType] = useState([]);
	const [testTypeList, setTestTypeList] = useState(null);
	const [testLink, setTestLink] = useState("");
	const [testPlatform, setTestPlatform] = useState("");
	const [platform, setplatform] = useState(null);
	const [testDuration, setTestDuration] = useState(null);
	const [testSchedule, setTestSchedule] = useState("");
	const [testInstruction, setTestInstruction] = useState("");
	const [jobappId, setjobappId] = useState(null);
	const [jobappNameId, setjobappNameId] = useState("");


	const getTestTypeList = async () => {
		try {
			const response = await axios.get(`/MasterDDL/GetCandidateAssignTestTypesDDL`)
			//   console.log("GetList==>",response)
			const TestTypeList = response.data.responseData.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setTestType(TestTypeList)
		}
		catch (error) {
			console.log("GetList==>", error);
		}
	}

	const handleTestType = (selectedOption) => {
		console.log("Selected City:", selectedOption);
		setTestTypeList(selectedOption ? selectedOption.value : null);
	};

	const getplatformList = async () => {
		try {
			const response = await axios.get(`/MasterDDL/GetOnlineProctoringPlatformDDL`)
			console.log("platform==>", response)
			const platformList = response.data.responseData.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setTestPlatform(platformList)
		}
		catch (error) {
			console.log("GetList==>", error);
		}
	}

	const handlePlatform = (selectedOption) => {
		//   console.log("Selected City:", selectedOption); 
		setplatform(selectedOption ? selectedOption.value : null);
	};


	useEffect(() => {
		getTestTypeList();
		getplatformList();
	}, [])

	const [showtestModal, setShowTestModal] = useState(false);
	const handleTestShow = () => setShowTestModal(true);
	const handleCloseTestModal = () => setShowTestModal(false);

	const TestAsign = async () => {
		try {
			if (!testName || !testTypeList || !testDuration || !testSchedule || !platform || !testLink) {
				toast.error("Fill all the required fields!");
				return;
			}

			if (!/^\d+$/.test(testDuration)) {
				toast.error("Test Duration should be a valid number!");
				return;
			}

			//  const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(\/\S*)?$/;
			const urlPattern = /^(https?:\/\/)?([\w\d.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/.*)?$/;

			if (!urlPattern.test(testLink)) {
				toast.error("Please enter a valid Test Link!");
				return;
			}

			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobappId,
				cnddtID: candidateId,
				cnddtType: jobappNameId === "Candidate" ? "Candidate" : "InsttCandidate",
				testName: testName,
				testType: testTypeList,
				testDurationMinutes: testDuration,
				scheduledAt: testSchedule,
				platform: platform,
				link: testLink,
				testInstructions: testInstruction,
				remark: testRemark
			};
			console.log("testdetail", requestBody);

			const response = await axios.post(
				"/JobApplication/AssignTestToCandidate",
				requestBody
			);

			toast.success(response.data.message)
			getInterviewShedule(1, "Candidate");

			JobAppGetAll();
			handleCloseTestModal();
			setTestType("");
			setTestName("");
			setTestRemark("");
			setTestInstruction("");
			setTestDuration(null);
			setTestSchedule("");
			setplatform(null);
			setTestLink("");
			// InstituteCandidateHiringStatus(candData);
		} catch (error) {
			toast.error(error.response.data.message);
			handleCloseTestModal();

			// toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};

	const TestAsignForInsCandid = async () => {
		try {
			if (!testName || !testTypeList || !testDuration || !testSchedule || !platform || !testLink) {
				toast.error("Fill all the required fields!");
				return;
			}

			if (!/^\d+$/.test(testDuration)) {
				toast.error("Test Duration should be a valid number!");
				return;
			}

			// const urlPattern = /^(http?:\/\/)?([\w\d-]+\.)+[\w]{2,}(\/.*)?$/;
			// const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/;

			// const testLink = "https://dev-web.jobbikhoj.com/interviews";

			const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/;

			if (!urlPattern.test(testLink)) {
				toast.error("Please enter a valid Test Link!");
				return;
			}

			// if (!urlPattern.test(testLink)) {
			// 	toast.error("Please enter a valid Test Link!");
			// 	return;
			// }

			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobappId,
				cnddtID: candidateId,
				cnddtType: jobappNameId === "Candidate" ? "Candidate" : "InsttCandidate",
				testName: testName,
				testType: testTypeList,
				testDurationMinutes: testDuration,
				scheduledAt: testSchedule,
				platform: platform,
				link: testLink,
				testInstructions: testInstruction,
				remark: testRemark
			};
			console.log("testdetail", requestBody);

			const response = await axios.post(
				"/JobApplication/AssignTestToCandidate",
				requestBody
			);

			toast.success(response.data.message)
			getInterviewShedule(1, "Institution");

			JobAppGetAll();
			handleCloseTestModal();
			setTestType("");
			setTestName("");
			setTestRemark("");
			setTestInstruction("");
			setTestDuration(null);
			setTestSchedule("");
			setplatform(null);
			setTestLink("");
			// InstituteCandidateHiringStatus(candData);
		} catch (error) {
			toast.error(error.response.data.message);
			handleCloseTestModal();

			// toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};

	// .................................shortDescription
	const addTargetBlankToAnchors = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;

		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML;
	};


	const linkifyContent = (htmlContent) => {
		const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription

	//   Columns
	const columns = [
		{
			name: "APPLIED DATE",
			center: true,
			sortable: true,
			minWidth: "150px",
			//   selector: (row) => row.jbApplctnTypeName,
			cell: (row) => (
				<>
					<div className="d-flex">
						<div
							style={{
								display: "flex",
								flexDirection: "column",
							}}

						>
							<div className="date-box">
								<div className="month text-center">
									{" "}
									{moment(row.appliedTime).format("MMM").toUpperCase()}
								</div>
								<div className="day text-center"> {moment(row.appliedTime).format("DD")}</div>
							</div>
							<p className="mb-1 mt-2"><span className="f-600">Time : </span>
								{moment.utc(row.appliedTime)
									.local()
									.format("hh : mm A")}
							</p>
						</div>
					</div>
				</>
			),
		},
		{
			name: "INTERVIEW DETAILS",
			// center: true,
			sortable: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					<div
						className="pt-2 pb-2"
						style={{
							display: "flex",
							flexDirection: "column",
						}}
					>
						<p className="mb-1"><span className="f-600">Date : </span>{moment(row.scheduleTime).format("DD MMM YYYY")}</p>
						<p className="mb-1"><span className="f-600">Time : </span>{moment.utc(row.scheduleTime).local().format("hh : mm  A")} </p>
						<p className="mb-1"><span className="f-600">Location : </span>{row.placeDetails}</p>
						{/* ⏰ */}
						<p className="mb-1"> <span className="f-600">Remark : </span> {row.remark}</p>
						<p className="mb-1"> <span className="f-600">Place Type : </span> {row.placeType}</p>

					</div>
				</>
			),
		},
		{
			name: "CANDIDATES",
			sortable: true,
			center: true,
			cell: (row) => (
				<div className="mt-2 mb-2 " style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
					{/* Row for Image and Username */}
					<div
						style={{
							display: "flex",
							alignItems: "center",
							flexDirection: "column",

						}}
					>
						{/* User Image */}
						{/* <Link
								to={`/Candidate/${row.userUid}`}>  */}
						<img
							src={row.userProfilePic}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
						{/* </Link> */}

						<div
							className="text-center"
						>
							{row.userName}
						</div>
					</div>

					{/* <div className="job-footer-left">
						<ul className="job-tag" style={{ margin: 0, padding: 0 }}>
							<Link
								to={`/Candidate/${row.userUid}`}>
								<li>
									{row.jbApplctnTypeName}
								</li>
							</Link>
						</ul>
					</div> */}
					{/* <div className="pointer">
                  {moment(row.appliedTime).format("YYYY-MM-DD")}
                </div> */}
				</div>
			),
		},
		{
			name: "JOB NAME",
			center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div className=" jobinfo f-600 pointer text-center"
							onClick={() => {
								handleInfoShow();
								JobInfoData(row.jobId)
							}}>
							{row.jobTitle}
						</div>
					</div>
				</div>
			),
			selector: (row) => row.jobTitle,
		},
		{
			name: "STATUS",
			center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<>
					<div className="row">

						<div className="d-flex hiringstatus-container">
							{row.jbApplctnType === 2 ? (
								row.hiringStatus === 9 ? (
									<div className="job-footer-left">
										<ul className="red" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								) : (
									<div className="job-footer-left">
										<ul className="green" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								)
							) : (
								<div
									style={{ display: "flex", flexDirection: "column", gap: "5px" }}
								>
									{row.hiringStatus === 1 ? (
										<div className="job-footer-left">
											<ul style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									) : row.hiringStatus === 5 ? (
										<div className="job-footer-left">
											<ul className="orange" style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									) : row.hiringStatus === 7 || row.hiringStatus === 8 ? <div className="job-footer-left">
										<ul className="red" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div> : (
										<div className="job-footer-left">
											<ul className="green" style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									)}
								</div>
							)}
							<span className="ms-2 history-pointer">
								<Tooltip title="History" arrow>
									<HistorySharpIcon
										onClick={() => {
											handleHistoryShow();
											JobHistory(row.jbApplctnId);
										}}
										className="pointer mt-0"
									/>
								</Tooltip>
							</span>
						</div>

						{userType === "Company" ? (

							row.isAssignedtoTest === true ? (
								<>
									<div className="d-flex  justify-content-start ">
										<a href="/AssignedTests">
											<p className="text-center green f-600 mt-1">Assigned To Test</p>
										</a>
									</div>
								</>
							) : ""
						) : ""}
					</div>
				</>
			),
		},
		{
			name: "Action",
			center: true,
			sortable: true,
			minWidth: "150px",
			cell: (row) => (
				<>
					<div className="d-block">
						{
							// row.hiringStatus === 2 ? (
							// 	<Tooltip title="Candidate List" arrow>
							// 		<PeopleSharpIcon
							// 			className="pointer"
							// 			onClick={() => {
							// 				handleInstModal();
							// 				setInstituteId(row.userUid);
							// 				setInstituteAppData(row);
							// 			}}
							// 		/>
							// 	</Tooltip>
							// ) :
							row.hiringStatus === 6 ||
								row.hiringStatus === 8 ||
								row.hiringStatus === 7 ? (
								""
							) : (
								<>
									<div className="d-flex mb-2">
										<span className="me-2">
											<Tooltip title="Reschedule" arrow>
												<CalendarMonthSharpIcon
													className="pointer "
													onClick={() => {
														handleShowModal();
														setjobAppId(row.jbApplctnId);
														setRemark(row.remark);
														setPlaceDetails(row.placeDetails);
														setPlaceType(mapPlaceTypeToValue[row.placeType] || "0"); // 🔁 mapping added

														const localMoment = moment.utc(row.scheduleTime).local();
														setScheduleTime(localMoment.format("YYYY-MM-DDTHH:mm")); //
													}}
												/>
											</Tooltip>
										</span>
										<span className="me-2 ">
											<Tooltip title="Update remark" arrow>
												<EditIcon
													className="blueIcon pointer"
													onClick={() => {
														handleShowRemark();
														setjobAppId(row.jbApplctnId);
														setjobAppType(row.jbApplctnTypeName);
														setUpdateRemark(row.remark)
														setintrvwId(row.intrvwID);

													}}
												/>
											</Tooltip>
										</span>

										<span className="me-2">
											<Tooltip title="Hire" arrow>
												<DoneIcon
													className="pointer checkIcon"
													onClick={() => {
														setShowConfirmationModal(true);
														setApplicationStatus("Hired");
														setjobAppId(row.jbApplctnId);
														//   AcceptApplication(row.jbApplctnId);
													}}
												/>
											</Tooltip>
										</span>

									</div>
									<span className="me-2">
										<Tooltip title="Reject" arrow>
											<ClearSharpIcon
												className="pointer rejectIcon"
												onClick={() => {
													setShowConfirmationModal(true);
													setApplicationStatus("Rejected");
													setjobAppId(row.jbApplctnId);
													// handleCancel();
													// getUpHiringStatus();
													// sethiringStatus(row.hiringStatus)
												}}
											/>
										</Tooltip>
									</span>
									<span>
										<Tooltip title="Block" arrow>
											<BlockSharpIcon
												className="pointer rejectIcon"
												onClick={() => {
													setShowConfirmationModal(true);
													setApplicationStatus("Blocked");
													setjobAppId(row.jbApplctnId);
													//   AcceptApplication(row.jbApplctnId);
												}}
											/>
										</Tooltip>
									</span>
									<span className="ms-2 ">
										<Tooltip title="View resume" arrow>
											<Link
												target="blank"
												to={`/Resume/Candidate?userUID=${row.userUid}`}
											// to={`/Resume?userUID=${row.userUid}`} 
											>
												<VisibilitySharpIcon className="ViewIcon" />
											</Link>
										</Tooltip>
									</span>
									{userType === "Company" || userType === "Recruiter" ? (

										row.isAssignedtoTest === false ? (
											<>
												<span className="ms-2 ">
													<Tooltip title="Assign Test" arrow>
														{/* <Link
												> */}
														<AssignmentSharpIcon
															onClick={() => {
																handleTestShow();
																setCandidateId(row.userUid);
																setjobappId(row.jbApplctnId);
																setjobappNameId(row.jbApplctnTypeName);
															}}
															className="blueIcon" />
														{/* </Link> */}
													</Tooltip>
												</span>
											</>
										) : ""
									) : ""}



								</>
							)}

					</div>


				</>
			),
		},
	];

	const [updateRemark, setUpdateRemark] = useState("");
	const [intrvwId, setintrvwId] = useState("");
	const [candidateId, setCandidateId] = useState("");

	//   Institute Columns

	const Inscolumns = [
		{
			name: "APPLIED DATE",
			center: true,
			sortable: true,
			minWidth: "150px",
			//   selector: (row) => row.jbApplctnTypeName,
			cell: (row) => (
				<>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
						}}
					>
						<div className="date-box">
							<div className="month text-center">
								{" "}
								{moment(row.appliedTime).format("MMM").toUpperCase()}
							</div>
							<div className="day text-center"> {moment(row.appliedTime).format("DD")}</div>
						</div>
						<p className="mb-1 mt-2"><span className="f-600">Time : </span>{moment.utc(row.appliedTime).local().format("hh : mm  A")} </p>
					</div>
				</>
			),
		},
		{
			name: "INTERVIEW DETAILS",
			// center: true,
			sortable: true,
			// minWidth: "200px",
			cell: (row) => (
				<>
					<div
						className="pb-2 pt-2"
						style={{
							display: "flex",
							flexDirection: "column",
						}}
					>
						<p className="mb-1"><span className="f-600">Date : </span>{moment(row.scheduleTime).format("DD MMM YYYY")}</p>
						<p className="mb-1"><span className="f-600">Time : </span>{moment.utc(row.scheduleTime).local().format("hh : mm  A")} </p>
						<p className="mb-1"><span className="f-600">Location : </span>{row.placeDetails}</p>
						<p className="mb-1"> <span className="f-600">Remark : </span> {row.remark}</p>
						<p className="mb-1"> <span className="f-600">Place Type : </span> {row.placeType}</p>
					</div>
				</>
			),
		},
		{
			name: "CANDIDATES",
			sortable: true,
			center: true,
			cell: (row) => (
				<div className="mt-2 mb-2" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>

					<div
						style={{
							display: "flex",
							alignItems: "center",
							flexDirection: "column",

						}}
					>
						{/* User Image */}
						{/* <Link
						 to={`/Candidate/${row?.instituteCandidateInterviewInfo?.cnddtUid}`}>  */}
						<img
							src={row?.instituteCandidateInterviewInfo?.cnddtProfilePic}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
						{/* </Link> */}
						<div style={{ color: "rgb(13 110 253)" }} className="f-600">

							<Tooltip title={
								<ul style={{ padding: '5px', margin: 0, listStyleType: 'none' }}>
									<li>Group Type : {row?.instituteCandidateInterviewInfo?.grpTypName}</li>
									{/* <li>User : {row?.userName}</li> */}
								</ul>
							} arrow>
								{row?.instituteCandidateInterviewInfo?.cnddtName}

								{/* <InfoOutlinedIcon fontSize="f-14" style={{ cursor: "pointer"  }} />							  */}
							</Tooltip>
						</div>
					</div>

					<div className="job-footer-left">
						<ul className="job-tag" style={{ margin: 0, padding: 0 }}>
							<Link
								to={`/Institution/${row.userUid}`}>
								<li className="mb-0">
									{row.userName}
								</li>
							</Link>
						</ul>
					</div>
				</div>
			),
		},
		{
			name: "JOB NAME",
			center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div className=" jobinfo f-600 pointer text-center"
							onClick={() => {
								handleInfoShow();
								JobInfoData(row.jobId)
							}}>
							{row.jobTitle}
						</div>
					</div>
					{/* <div className="text-center">{row.shortDescription}</div> */}
				</div>
			),
			selector: (row) => row.jobTitle,
		},
		{
			name: "STATUS",
			center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<>
					<div className="row">

						<div className="d-flex  hiringstatus-container">
							{row.jbApplctnType === 2 ? (
								row.hiringStatus === 9 ? (
									<div className="job-footer-left">
										<ul className="red" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								) : row.hiringStatus === 5 ? (
									<div className="job-footer-left">
										<ul className="orange" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								) : row.hiringStatus === 7 || row.hiringStatus === 8 ? (
									<div className="job-footer-left">
										<ul className="red" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								) : (
									<div className="job-footer-left">
										<ul className="green" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div>
								)
							) : (
								<div
									style={{ display: "flex", flexDirection: "column", gap: "5px" }}
								>
									{row.hiringStatus === 1 ? (
										<div className="job-footer-left">
											<ul style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									) : row.hiringStatus === 5 ? (
										<div className="job-footer-left">
											<ul className="orange" style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									) : row.hiringStatus === 7 || row.hiringStatus === 8 ? <div className="job-footer-left">
										<ul className="red" style={{ margin: 0, padding: 0 }}>
											<li>
												{row.hiringStatusName}
											</li>
										</ul>
									</div> : (
										<div className="job-footer-left">
											<ul className="green" style={{ margin: 0, padding: 0 }}>
												<li>
													{row.hiringStatusName}
												</li>
											</ul>
										</div>
									)}
								</div>
							)}
						</div>
						{row.isAssignedtoTest === true ? (
							<>
								<div className="d-flex  justify-content-start">
									<a href="/AssignedTests">
										<p className="text-center green f-600 mt-1">Assigned To Test</p>
									</a>
								</div>
							</>
						) : ""}
					</div>

				</>
			),
		},
		{
			name: "Action",
			center: true,
			sortable: true,
			minWidth: "150px",
			cell: (row) => (


				<>
					<div className="d-block">
						{
							// row.hiringStatus === 2 ? (
							// 	<Tooltip title="Candidate List" arrow>
							// 		<PeopleSharpIcon
							// 			className="pointer"
							// 			onClick={() => {
							// 				handleInstModal();
							// 				setInstituteId(row.userUid);
							// 				setInstituteAppData(row);
							// 			}}
							// 		/>
							// 	</Tooltip>
							// ) :
							row.hiringStatus === 6 ||
								row.hiringStatus === 8 ||
								row.hiringStatus === 7 ? (
								""
							) : (
								<>
									<div className="d-flex mb-2">
										<span className="me-2">
											<Tooltip title="Reschedule" arrow>
												<CalendarMonthSharpIcon
													className="pointer "
													onClick={() => {

														handleShowModalScheule();
														setjobAppId(row.jbApplctnId);
														setgrpTypeId(row?.instituteCandidateInterviewInfo?.grpTypeId);
														setgrpTypename(row?.instituteCandidateInterviewInfo?.grpTypName);
														setcandidId(row?.instituteCandidateInterviewInfo?.cnddtID)
														setInsttUid(row?.userUid)
														setRemark(row.remark);
														setPlaceDetails(row.placeDetails);
														setPlaceType(mapPlaceTypeToValue[row.placeType] || "0"); // 🔁 mapping added

														const localMoment = moment.utc(row.scheduleTime).local();
														setScheduleTime(localMoment.format("YYYY-MM-DDTHH:mm"));
														// const localMoment = moment.utc(row.scheduleTime).local();
														// setScheduleTime(localMoment.format("YYYY-MM-DDTHH:mm"));

													}}
												/>
											</Tooltip>
										</span>
										<span className="me-2 ">
											<Tooltip title="Update remark" arrow>
												<EditIcon
													className="blueIcon pointer"
													onClick={() => {
														handleShowInsRemark();
														setjobAppId(row.jbApplctnId);
														setjobAppType(row.jbApplctnTypeName);
														setUpdateRemark(row.remark);
														setintrvwId(row.intrvwID);
														setcandidId(row?.instituteCandidateInterviewInfo?.cnddtID)


													}}
												/>
											</Tooltip>
										</span>

										<span className="me-2">
											<Tooltip title="Hire" arrow>
												<DoneIcon
													className="pointer checkIcon"
													onClick={() => {
														setShowConfirmationModalIns(true);
														setApplicationStatusIns("Hired");
														setjobAppId(row.jbApplctnId);
														setgrpTypeId(row?.instituteCandidateInterviewInfo?.grpTypeId);
														setgrpTypename(row?.instituteCandidateInterviewInfo?.grpTypName);
														setcandidId(row?.instituteCandidateInterviewInfo?.cnddtID)
														setInsttUid(row?.userUid)
													}}
												/>
											</Tooltip>
										</span>

									</div>
									<span className="me-2">
										<Tooltip title="Reject" arrow>
											<ClearSharpIcon
												className="pointer rejectIcon"
												onClick={() => {
													setShowConfirmationModalIns(true);
													setApplicationStatusIns("Rejected");
													setjobAppId(row.jbApplctnId);
													setgrpTypeId(row?.instituteCandidateInterviewInfo?.grpTypeId);
													setgrpTypename(row?.instituteCandidateInterviewInfo?.grpTypName);

													setcandidId(row?.instituteCandidateInterviewInfo?.cnddtID)
													setInsttUid(row?.userUid)
												}}
											/>
										</Tooltip>
									</span>
									<span>
										<Tooltip title="Block" arrow>
											<BlockSharpIcon
												className="pointer rejectIcon"
												onClick={() => {
													setShowConfirmationModalIns(true);
													setApplicationStatusIns("Blocked");
													setjobAppId(row.jbApplctnId);
													setgrpTypeId(row?.instituteCandidateInterviewInfo?.grpTypeId);
													setgrpTypename(row?.instituteCandidateInterviewInfo?.grpTypName);
													setcandidId(row?.instituteCandidateInterviewInfo?.cnddtID)
													setInsttUid(row?.userUid)
												}}
											/>
										</Tooltip>
									</span>
									<span className="ms-2 ">
										<Tooltip title="View resume" arrow>
											<Link
												target="blank"
												to={`/Resume?userUID=${row?.instituteCandidateInterviewInfo?.cnddtUid}&InstnCnddtId=${row?.instituteCandidateInterviewInfo?.insttCnddtID}`}
												
											>
												<VisibilitySharpIcon className="ViewIcon" />
											</Link>
										</Tooltip>
									</span>

									{userType === "Company" || userType === "Recruiter" ? (

										row.isAssignedtoTest === false ? (
											<>
												<span className="ms-2 ">
													<Tooltip title="Assign Test" arrow>

														<AssignmentSharpIcon
															onClick={() => {
																handleTestShow();
																setCandidateId(row?.instituteCandidateInterviewInfo?.cnddtID);
																setjobappId(row?.jbApplctnId);
															}}
															className="blueIcon" />
													</Tooltip>
												</span>
											</>
										) : ""
									) : ""}


								</>
							)}

					</div>


				</>
			),
		},

	]

	// .............................................
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);



	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Updated values
		const updatedScheduleTime = fieldName === "scheduleTime" ? value : scheduleTime;
		const updatedPlaceType = fieldName === "placeType" ? value : placeType;
		const updatedPlaceDetails = fieldName === "placeDetails" ? value : placeDetails;

		// Check if all required fields are filled

		// Check if all required fields are filled
		const allFieldsFilled =
			updatedScheduleTime &&
			updatedPlaceType !== "0" && // Ensure a valid option is selected
			updatedPlaceDetails.trim() !== "";

		setFormChanged(allFieldsFilled);
	};

	// .........................................Remarl Handle
	const [formValid, setFormValid] = useState(false);

	const handleFieldChangeNew = (setter, value, fieldName) => {
		setter(value);

		// Updated values
		const updatedRemark = fieldName === "updateRemark" ? value : updateRemark;

		// Check if the field is filled
		const isValid = updatedRemark.trim() !== "";

		setFormValid(isValid);
	};


	return (
		<>
			<section className="pricing-section-three container jobapplication interviews application-drop-section">
				<div className="row">
					<div className="delete-title mb-1 col-6">
						<h1 className="orange-title">
							<span className="orange-box me-2"></span>
							Interviews
						</h1>
					</div>
					<div className="mb-1 col-6 text-start"></div>
				</div>
				<div className="container st3">

					<div className="tabButton d-flex w-100 ps-0 connectionTab mb-2">

						<button
							onClick={() => handleTabChange(1)}
							style={tabStyle(interviewType === "Candidate")}
						>
							Candidate
						</button>
						<button
							onClick={() => handleTabChange(2)}
							style={tabStyle(interviewType === "Institution")}
						>
							Institution
						</button>
					</div>
					<div className="row">
						<div className="col-lg-12">
							{/* <div className="manage-batches-container">
								<h2 className="manage-heading">{interviewType} List</h2>
							</div> */}
							{isLoading ? (
								<div className="row mt-2">
									<div className="col-md-12">
										<ShimmerDiv mode="light" height={120} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={120} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={120} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={120} width={'100%'} />
									</div>
								</div>
							) : isError ? (
								<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
									<img src={error} alt="404 Not Found" width={300} />
									{/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
								</div>

							) : interviewData.length === 0 && (interviewType === "Institution" || interviewType === "Candidate") ? (
								<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
									<img src={error} alt="404 Not Found" width={300} />
								</div>
							) : (
								<>
									{interviewType === "Candidate" ? (
										<>
											<div className="table-res">
												<div className="react-dataTable react-table-colorclass">
													<DataTable
														noHeader
														pagination
														columns={columns}
														data={interviewData}
														progressPending={isLoading}
														paginationServer
														paginationPerPage={10}
														paginationTotalRows={totalRows}
														paginationRowsPerPageOptions={[]}
														onChangePage={(page) => {
															setCurrentPage(page); // Update the current page
														}}
														sortIcon={<ChevronDown size={10} />}
														className="react-dataTable"
													/>
												</div>
											</div>
										</>
									) : (
										<>
											<div className="table-res">
												<div className="react-dataTable react-table-colorclass">
													<DataTable
														noHeader
														pagination
														columns={Inscolumns}
														// columns={columns}
														data={interviewData}
														progressPending={isLoading}
														paginationServer
														paginationPerPage={10}
														paginationTotalRows={totalRows}
														paginationRowsPerPageOptions={[]}
														onChangePage={(page) => {
															setCurrentPage(page); // Update the current page
														}}
														sortIcon={<ChevronDown size={10} />}
														className="react-dataTable"
													/>
												</div>
											</div>
										</>
									)}
								</>
							)}
						</div>
					</div>

				</div>
			</section>



			<Modal
				show={showInstModal}
				onHide={handleCloseInstModal}
				centered
				size="lg"
			>
				<Modal.Header>
					<Modal.Title> Institute candidate details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInstModal} />
				</Modal.Header>
				<Modal.Body className="settings jobapplication">
					<div className="container st3">
						<div className="row">
							<div className="col-lg-12">
								<div className="manage-search-bar">
									<SearchIcon className="icon" />
									<input
										type="text"
										placeholder="Search..."
										className="manage-search-input Dark-Manage-Search"
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
								{isLoading ? (
									<div className="row mt-2">
										<div className="col-md-12">
											<ShimmerDiv mode="light" height={120} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={120} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={120} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={120} width={'100%'} />
										</div>
									</div>
								) : isError ? (
									<div className="mt-2 error-image-cont error-cont">
										<img src={error} alt="404 Not Found" width={300} />
									</div>
								) : (
									<div className="table-res">
										<div className="react-dataTable">
											<DataTable
												noHeader
												pagination
												columns={Inscolumns}
												paginationPerPage={10}
												className="react-dataTable"
												sortIcon={<ChevronDown size={10} />}
												paginationDefaultPage={currentPage + 1}
												data={InsCandidateList}
											/>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</Modal.Body>
				{/* <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            onClick={handleCloseInfo}
          >
            Submit
          </button>
        </Modal.Footer> */}
			</Modal>

			<Modal show={showAcceptModal} onHide={handleClose} centered>
				<Modal.Header>
					<Modal.Title>Re-schedule Meeting</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleClose} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className="row">
						<div className="col-md-12 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Date
							</label>
							<Flatpickr
							// data-enable-time
							// value={date}
							// onChange={([date]) => {
							//     this.setState({ date });
							// }}
							/>
						</div>
						<div className="col-md-6 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Time
							</label>
							<Flatpickr
								options={{
									enableTime: true,
									noCalendar: true,
									dateFormat: "H:i", // Format for time only
									time_24hr: true, // Optional: for 24-hour format
								}}
							/>
						</div>
						<div className="col-md-6 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Time Duration
							</label>
							<input
								type="text"
								style={{ width: "100%" }}
							// value={contactNo}
							// onChange={(e) => setContactNo(e.target.value)}
							/>
						</div>
						<div className="col-md-12 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Message
							</label>
							<textarea />
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<div className="khojPrimaryBtn1 ms-3 w-100">
						<Link to="/" className="">
							Re-schedule Meeting
						</Link>
					</div>
				</Modal.Footer>
			</Modal>

			<Modal show={showUserInfo} onHide={handleCloseInfo} centered size="md">
				<Modal.Header>
					<Modal.Title> Interview Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInfo} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Col md={12}>
						<div className="post-form-group d-flex flex-row">
							<label htmlFor="about">
								<div>{/* <h2>IMG</h2> */}</div>
							</label>
							<div className="px-2">
								<label htmlFor="schedule-time">
									<h5>Ashh</h5>
								</label>
								<h6>FrontEnd Engineer</h6>
								<h6>React JS</h6>
							</div>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="schedule-time">
								Hiring Status :{" "}
								<span className="ms-2">{jobAppInfoData.hiringStatusName}</span>
							</label>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Job Time:{" "}
								<span className="ms-2">{jobAppInfoData.typeName}</span>
							</label>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Type: <span className="ms-2">{jobAppInfoData.rateType}</span>
							</label>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Scheduled Time:{" "}
								<span className="ms-2">June 13 , 2024 , 05:30 am</span>
							</label>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Remark: <span className="ms-2"></span>
							</label>
						</div>
					</Col>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger apply-job me-2"
						onClick={handleCloseInfo}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/* ..................candidate re-shedule............. */}
			<Modal show={showAppliedModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title>Interview Re-Schedule Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Col md={12} className="mb-2">

						<div className="post-form-group">
							<label htmlFor="about">
								Schedule Time{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<Flatpickr
								data-enable-time
								value={scheduleTime}
								// onChange={(selectedDates) => {setScheduleTime(selectedDates[0]);}}
								onChange={(selectedDates) => handleFieldChange(setScheduleTime, selectedDates[0], "scheduleTime")}
								options={{
									enableTime: true,
									dateFormat: "Y-m-d    h:i K",
									minDate: new Date(),
									static: true, // Keeps the calendar visible on click         
								}}
								className="form-control Dark-Input-from-group"
								placeholder="Enter schedule time"
							/>
						</div>

					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="schedule-time">
								Interview Mode Type{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<select
								// id="schedule-time"
								// className="form-control"
								// placeholder="Select"
								id="place-type"
								value={placeType}
								// onChange={(e) => setPlaceType(e.target.value)}
								onChange={(e) => handleFieldChange(setPlaceType, e.target.value, "placeType")}
								className="form-control  Dark-Input-from-group"
							>
								<option value="0"> Select </option>
								<option value="1">OnSite</option>
								<option value="2">Remote</option>
								<option value="3">Hybrid</option>
							</select>
						</div>
					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="about">
								Place Details{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<input
								// type="text"
								// placeholder="Enter class name"
								type="text"
								value={placeDetails}
								// onChange={(e) => setPlaceDetails(e.target.value)}
								onChange={(e) => handleFieldChange(setPlaceDetails, e.target.value, "placeDetails")}
								placeholder="Enter place details"
								className="form-control  Dark-Input-from-group"
							/>
						</div>
					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="about">
								Remark
							</label>
							<textarea
								as="textarea"
								rows={3}
								className="Dark-Input-from-group"
								value={remark}
								onChange={(e) => setRemark(e.target.value)}
								placeholder="Enter Remark"
							/>
						</div>
					</Col>
				</Modal.Body>
				<Modal.Footer>
					<button
						className={`btn btn-danger apply-job me-2 ${!formChanged ? "disabled" : ""}`}
						onClick={ScheduleInterview}
						disabled={!formChanged}
					>
						Submit
					</button>


				</Modal.Footer>
			</Modal>

			<Modal show={showConfirmationModal} onHide={handleCancel} centered>
				<Modal.Header>
					<Modal.Title>Confirmation</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCancel} />
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to do ?</p>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger"
						onClick={() => {
							if (applicationStatus === "Hired") {
								AcceptApplication(jobAppId, "Hired");
							} else if (applicationStatus === "Blocked") {
								AcceptApplication(jobAppId, "Blocked");
							} else if (applicationStatus === "Rejected") {
								AcceptApplication(jobAppId, "Rejected");
							}
							// handleDeleteRow(jobAppId);
							// handleCloseCancelModal();
						}}
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>

			{/*     ................. candidate remark ............. */}
			<Modal show={showRemarkModal} onHide={handleCloseRemark} centered>
				<Modal.Header>
					<Modal.Title>Update remark</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseRemark} />
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Remark
							</label>
							<input
								type="text"
								style={{ width: "100%" }}
								value={updateRemark}
								// onChange={(e) => setUpdateRemark(e.target.value)}
								onChange={(e) => handleFieldChangeNew(setUpdateRemark, e.target.value, "updateRemark")}
							/>
							{displays && !updateRemark ? (
								<span className="error_msg_lbl text-red">
									Remark cannot be empty{" "}
								</span>
							) : null}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className={`btn khojPrimaryBtn ${!formValid ? "disabled" : ""}`}
						onClick={remarkUpdateFn}
						disabled={!formValid}
					>
						Update
					</button>

				</Modal.Footer>
			</Modal>

			{/*     ................. institution remark ............. */}
			<Modal show={showInsRemarkModal} onHide={handleCloseInsRemark} centered>
				<Modal.Header>
					<Modal.Title>Update remark</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInsRemark} />
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Remark
							</label>
							<input
								type="text"
								style={{ width: "100%" }}
								value={updateRemark}
								// onChange={(e) => setUpdateRemark(e.target.value)}
								onChange={(e) => handleFieldChangeNew(setUpdateRemark, e.target.value, "updateRemark")}
							/>
							{displays && !updateRemark ? (
								<span className="error_msg_lbl text-red">
									Remark cannot be empty{" "}
								</span>
							) : null}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{/* <button
						className="btn khojPrimaryBtn"
						onClick={() => {

							remarkUpdateInsCandi();
						}}
					>
						Update
					</button> */}

					<button
						className={`btn khojPrimaryBtn ${!formValid ? "disabled" : ""}`}
						onClick={remarkUpdateInsCandi}
						disabled={!formValid}
					>
						Update
					</button>

				</Modal.Footer>
			</Modal>

			{/* ......................confirmation modal.............. */}
			<Modal
				show={showConfirmationModalIns}
				onHide={handleCancelIns}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirmation</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCancelIns} />
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to do?</p>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger"
						onClick={() => {
							if (applicationStatusIns === "Hired") {
								AcceptApplicationAsInst(jobAppId, "Hired");
							} else if (applicationStatusIns === "Blocked") {
								AcceptApplicationAsInst(jobAppId, "Blocked");
							} else if (applicationStatusIns === "Rejected") {
								AcceptApplicationAsInst(jobAppId, "Rejected");
							}
						}}
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>

			{/* ..................Institution candidate re-shedule............. */}

			<Modal show={showAppliedModalScheule}
				onHide={handleCloseModalScheule}
				centered
			>
				<Modal.Header>
					<Modal.Title>Interview Re-Schedule Details</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseModalScheule}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="about">
								Schedule Time{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<Flatpickr
								data-enable-time
								value={scheduleTime}
								// onChange={(selectedDates) => {setScheduleTime(selectedDates[0]);}}
								onChange={(selectedDates) => handleFieldChange(setScheduleTime, selectedDates[0], "scheduleTime")}
								options={{
									enableTime: true,
									dateFormat: "Y-m-d    h:i K",
									minDate: new Date(),
									static: true, // Keeps the calendar visible on click         
								}}
								className="form-control Dark-Input-from-group"
								placeholder="Enter schedule time"
							/>
						</div>
					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="schedule-time">
								Interview Mode Type{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<select
								id="place-type"
								value={placeType}
								// onChange={(e) => setPlaceType(e.target.value)}
								onChange={(e) => handleFieldChange(setPlaceType, e.target.value, "placeType")}
								className="form-control Dark-Input-from-group"
							>
								<option value="0"> Select </option>
								<option value="1">OnSite</option>
								<option value="2">Remote</option>
								<option value="3">Hybrid</option>
							</select>
						</div>
					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="about">
								Place Details{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<input
								// type="text"
								// placeholder="Enter class name"
								type="text"
								value={placeDetails}
								// onChange={(e) => setPlaceDetails(e.target.value)}
								onChange={(e) => handleFieldChange(setPlaceDetails, e.target.value, "placeDetails")}
								placeholder="Enter place details"
								className="form-control Dark-Input-from-group"
							/>
						</div>
					</Col>

					<Col md={12} className="mb-2">
						<div className="post-form-group">
							<label htmlFor="about">
								Remark
							</label>
							<textarea
								as="textarea"
								rows={3}
								className="Dark-Input-from-group"
								value={remark}
								onChange={(e) => setRemark(e.target.value)}
								placeholder="Enter Remark"
							/>
						</div>
					</Col>
				</Modal.Body>
				<Modal.Footer>
					{/* <button
						className="btn btn-danger apply-job me-2"
						onClick={ScheduleInterviewAsInst}
					>
						Submit
					</button> */}
					<button
						className={`btn btn-danger apply-job me-2 ${!formChanged ? "disabled" : ""}`}
						onClick={ScheduleInterviewAsInst}
						disabled={!formChanged}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/*.................................... History Job Modal Start ................................*/}

			<Modal show={showHistoryModal} onHide={handleCloseHistoryModal} centered>
				<Modal.Header>
					<Modal.Title> Job history</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseHistoryModal}
					/>
				</Modal.Header>
				<Modal.Body className="settings" >
					{jobHistory && jobHistory.length > 0 ? (
						jobHistory.map(
							(data, index) => (
								(

									<div
										className="profile-resume-user-acvtivity mt-4"
										key={index} >
										<div className="d-flex justify-content-between mb-2 align-center">
											<div className="d-flex align-items-center ">
												<div
													className={`profile-resume-applied-status me-2 ${data.hiringStatus === 1 || data.hiringStatus === 9
														? "profile-resume-initial-icon"
														: data.hiringStatus === 5
															? "profile-resume-cv-icon"
															: data.hiringStatus === 4 || data.hiringStatus === 6
																? "profile-resume-success-icon"
																: ""
														}`}
												></div>
												<div className="profile-resume-applied-jobs f-16 f-700 ">
													Hiring Status : {data.hiringStatusName}
												</div>
											</div>
											<div className="profile-resume-user-activity-time f-14 f-400">
												<span className="f-600">
													{moment
														.utc(data.time)
														.local()
														.format("DD MMM YYYY -- hh : mm A")} </span>
											</div>
										</div>
										<div className="profile-resume-user-actvity-container mb-3">
											{data.remark === "" ? '' : (

												<p className="f-14 f-400 mb-1"><span className="f-600">Remark : </span> {data.remark}</p>
											)}
											{data.scheduledInterviewInfo === null ? '' : (
												<>
													<h6 className="f-600 mb-1"> <u>Interview Details</u> </h6>
													{data.scheduledInterviewInfo.placeDetails === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Location : </span>
															{data.scheduledInterviewInfo.placeDetails}
														</p>
													)}
													{data.scheduledInterviewInfo.remark === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Remark : </span>
															{data.scheduledInterviewInfo.remark}
														</p>
													)}
													{data.scheduledInterviewInfo.placeType === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Place Type : </span>
															{data.scheduledInterviewInfo.placeType}
														</p>
													)}
													{data.scheduledInterviewInfo.scheduleTime === null ? '' : (
														<div className="profile-resume-pdf-text f-14 f-500 d-conntents ">
															<CalendarMonthSharpIcon className="me-1" /> Date : {moment.utc(data.scheduledInterviewInfo.scheduleTime)
																.local()
																.format("DD MMM YYYY - hh : mm A")}
															{/* {moment(data.scheduledInterviewInfo.scheduleTime).format("DD-MM-YYYY")} */}
														</div>
													)}
												</>

											)}
										</div>
									</div>
								)
							)
						)
					) : (
						<p>No job history available.</p>
					)}
				</Modal.Body>

			</Modal>
			{/*.................................... history Job Modal End ................................*/}

			{/*.................................... Info Job Modal Start ................................*/}

			<Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
				<Modal.Header>
					<Modal.Title>Job Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						{jobInfo.title === "" ? '' : (
							<p>
								<span className="f-600">Title : </span>
								{jobInfo.title}
							</p>
						)}

						{jobInfo.compName === null ? "" : (
							<p>
								<span className="f-600"> Company : </span>
								{jobInfo.compName}
							</p>
						)}
						{jobInfo.cityName === null ? "" : (
							<p>
								<span className="f-600">City : </span>
								{jobInfo.cityName}
							</p>
						)}
						{jobInfo.designationName === null ? "" : (
							<p>
								<span className="f-600">Designation :</span> {jobInfo.designationName}
							</p>
						)}
						{jobInfo.workLocationTypeName === null ? "" : (
							<p>
								<span className="f-600">Work Location :</span> {jobInfo.workLocationTypeName}
							</p>
						)}
						{jobInfo.description === "" ? "" : (
							<p>
								{/* <span className="f-600"> Description : </span>
								{jobInfo.description} */}
								<strong> Description : </strong><div className=""
									dangerouslySetInnerHTML={{
										__html: linkifyContent(
											addTargetBlankToAnchors(jobInfo.description)
										)
									}}
								>
								</div>
							</p>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Link
						to={`/job/${jobInfo?.jobId}`}
						className="btn khojPrimaryBtn me-2"
					>
						View
					</Link>
				</Modal.Footer>
			</Modal>

			{/*.................................... Info Job Modal End ................................*/}

			{/*.................................... Test Assign Modal End ................................*/}

			<Modal show={showtestModal} onHide={handleCloseTestModal} centered size="lg">
				<Modal.Header>
					<Modal.Title> Assign Test</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseTestModal} />
				</Modal.Header>
				<Modal.Body>

					<div className="row  mt-2 align-center">

						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Name<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Test Name"
									type="text"
									style={{ width: "100%" }}
									value={testName}
									onChange={(e) => setTestName(e.target.value)}
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group text-transform-email">
								<label htmlFor="about" className="f-14 f-700">
									Link<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Link"
									type="text"
									style={{ width: "100%" }}
									value={testLink}
									onChange={(e) => setTestLink(e.target.value)}
								/>
							</div>
						</Col>

						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Type<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>

								<ReactSelect
									options={testType}
									onChange={handleTestType} // Select hone ke baad clear ho jaye
									placeholder="Select Test Type"

									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
									isClearable
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Platform<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<ReactSelect
									options={testPlatform}
									onChange={handlePlatform} // Select hone ke baad clear ho jaye
									placeholder="Select Platform"

									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
									isClearable
								/>
							</div>
						</Col>


						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Duration Minutes<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Test Duration"
									type="text"
									style={{ width: "100%" }}
									value={testDuration}
									onChange={(e) => setTestDuration(e.target.value)}
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14">
									Schedule Time{" "}
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<Flatpickr
									data-enable-time
									value={testSchedule}
									onChange={(selectedDates) => {
										setTestSchedule(selectedDates[0]);
									}}
									options={{
										enableTime: true,
										dateFormat: "Y-m-d H:i",
										minDate: new Date(),
										static: true, // Keeps the calendar visible on click         
									}}
									className="form-control Dark-Input-from-group"
									placeholder="Enter schedule time"
								/>
							</div>
						</Col>
						<Col md={12} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Remark
								</label>
								<textarea
									placeholder="Enter Remark"
									type="text"
									style={{ width: "100%" }}
									value={testRemark}
									onChange={(e) => setTestRemark(e.target.value)}
								/>
							</div>
						</Col>
					</div>
					<div className="row">

						<Col md={12} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Instructions
								</label>
								<textarea
									placeholder="Enter Instruction"
									type="text"
									style={{ width: "100%" }}
									value={testInstruction}
									onChange={(e) => setTestInstruction(e.target.value)}
								/>
							</div>
						</Col>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn khojPrimaryBtn"
						onClick={() => {
							if (jobappNameId === "Candidate") {
								TestAsign();
							} else {
								TestAsignForInsCandid();
							}
						}}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/*.................................... Assign test Modal end ................................*/}

			{/* ...............UnAuthorize modal............  */}
			{unAuthorizeError ? (
				<Modal show={unauthModal} centered>
					<Modal.Header>
						<Modal.Title>Unauthorize session expired</Modal.Title>
					</Modal.Header>
					<Modal.Body className="settings">
						<div className=" mb-3">
							<p>{unAuthorizeError}</p>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link
							className="pointer"
							to="/Login"
							onClick={() => {
								localStorage.removeItem("token"); // Remove authentication token
								sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
								localStorage.removeItem("Module");
							}}
						>
							<button className="btn btn-danger ">Login</button>
						</Link>
						{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

					</Modal.Footer>

				</Modal>
			) : (
				""
			)}
		</>
	);
};

export default InterviewSchedule;
